import { Outlet, createFileRoute } from '@tanstack/react-router';

import { VStack } from '@/components/Layout';

import { CertificationProfileHeader } from './_layout/_index/-components/CertificationProfileHeader';

export const Route = createFileRoute(
  '/_staff/certification/handling-certification/$id/_layout',
)({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <VStack className="gap-0">
      <CertificationProfileHeader />
      <Outlet />
    </VStack>
  );
}
